import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { tokenToPixelSize, tokenToBorderRadius } from '../../tokens/size-tokens/size-to-pixels.js';

var Squircle = function Squircle(_a) {
  var _a$size = _a.size,
    size = _a$size === undefined ? 'medium' : _a$size,
    children = _a.children,
    style = _a.style;
    _a.outline;
    var color = _a.color,
    stacked = _a.stacked,
    otherProps = __rest(_a, ["size", "children", "style", "outline", "color", "stacked"]);
  var pixelSize = typeof size === 'number' ? size : tokenToPixelSize(size);
  var borderRadius = typeof size === 'number' ? size > 30 && 8 : tokenToBorderRadius(size);
  var squirclePath = 'M0.00118064 0.5C0.00118064 -0.0487014 -0.0487013 0.00118064 0.5 0.00118064C1.0487 0.00118064 0.998819 -0.0487013 0.998819 0.5C0.998819 1.0487 1.0487 0.998819 0.5 0.998819C-0.0487013 0.998819 0.00118064 1.0487 0.00118064 0.5Z';
  var stackedSquirclePath = 'M0.892786 0.0153224C0.81416 -0.00634925 0.695999 0.00131565 0.499874 0.00131565C0.225592 0.00131565 0.100919 -0.0111517 0.044816 0.0449513C-0.011287 0.101054 0.00118033 0.225728 0.00118033 0.500009C0.00118033 0.77429 -0.011287 0.898963 0.044816 0.955066C0.100919 1.01117 0.225592 0.998702 0.499874 0.998702C0.695999 0.998702 0.81978 1.00628 0.892678 0.984804C0.853217 0.940726 0.838885 0.881585 0.835162 0.812336C0.832482 0.762481 0.833008 0.699494 0.833646 0.622969C0.833961 0.585283 0.834303 0.544309 0.834303 0.500009C0.834303 0.455709 0.833961 0.41474 0.833646 0.377055C0.833008 0.30053 0.832482 0.237537 0.835162 0.187681C0.838885 0.118433 0.853326 0.0593997 0.892786 0.0153224Z';
  return jsxs("div", {
    className: classNames('cogs-v10', 'cogs-squircle', stacked && 'cogs-squircle--stacked', pixelSize < 30 && 'cogs-squircle--size-small'),
    style: {
      height: pixelSize,
      width: pixelSize
    },
    children: [jsx("svg", {
      className: "cogs-v10 cogs-squircle__mask",
      viewBox: "0 0 1 1",
      xmlns: "http://www.w3.org/2000/svg",
      children: jsxs("defs", {
        children: [jsx("clipPath", {
          id: "cogs-squircle--default",
          clipPathUnits: "objectBoundingBox",
          children: jsx("path", {
            d: squirclePath
          })
        }), jsx("clipPath", {
          id: "cogs-squircle--stacked",
          clipPathUnits: "objectBoundingBox",
          children: jsx("path", {
            d: stackedSquirclePath
          })
        })]
      })
    }), jsx("div", Object.assign({
      className: "cogs-v10 cogs-squircle__masked-container",
      style: Object.assign(Object.assign({
        background: color
      }, style), {
        height: pixelSize,
        width: pixelSize,
        borderRadius: borderRadius || 4
      })
    }, otherProps, {
      children: children
    })), jsx("svg", {
      width: size + "px",
      height: size + "px",
      viewBox: "0 0 1 1",
      className: "cogs-v10 cogs-squircle__focus-ring",
      children: jsx("path", {
        vectorEffect: "non-scaling-stroke",
        fill: "none",
        stroke: "var(--cogs-border--interactive--hover)",
        strokeWidth: "2",
        d: stacked ? stackedSquirclePath : squirclePath
      })
    })]
  });
};

export { Squircle };
